export default {
  greeting: 'Olá',
  logout: 'Sair',
};
